import { styled } from 'solid-styled-components';
import { Link } from '@solidjs/router';
import theme from '../../style/theme';

export type StyledImageProps = {
    animate?: boolean;
    lowRes?: boolean;
};

export const StyledCourseCard = styled(Link)`
    max-height: 33.5rem;
    display: flex;
    flex-direction: column;
    border-radius: 1.43rem;
    height: 100%;
    min-height: 27.6rem;
    width: 100%;
    background-color: white;
    list-style: none;
    position: relative;
    text-decoration: none;
    border: 1px solid #BEB9B9;
    transition: transform 0.2s, box-shadow 0.2s;

    &:hover {
        box-shadow: 0.2rem 0.2rem 0.86rem 0px rgba(0, 0, 0, 0.09);
        transform: scale(0.97);
    }
`;

export const StyledCourseCardTop = styled.div`
    position: relative;
    height: 15rem;
`;

export const StyledCourseCardImage = styled.img<StyledImageProps>`
    background-color: ${theme.palette.lightBeige};
    border-radius: 1.37rem 1.37rem 0 0;
    width: 100%;
    object-fit: cover;
    object-position: center;
    height: 100%;

    position: absolute;
    top: 0;
    left: 0;
    /* z-index: ${(p) => (p.lowRes ? 1 : 0)}; */
    z-index: 0;
    animation-delay: 0.05s;
    ${p => p.animate ? `
        animation: fadeOut 0.8s ease-out ${p.lowRes ? 'forwards' : 'backwards'};
    ` : `
        animation: none;
    `}

    @keyframes fadeOut {
        0% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }
`;

export const StyledCourseCardBottom = styled.div`
    height: 18.5rem;
    position: relative;
    border-top: 1px solid ${theme.palette.beige};
`;

export const StyledCourseCardText = styled.div<{ inProgress: boolean }>`
    padding: 2rem;
    padding-top: 2rem;
    display: flex;
    flex-direction: column;
    padding-bottom: ${(props) => (props.inProgress ? '1.5rem' : '2rem')};
`;

export const StyledCourseCardImagePlaceholder = styled.div<StyledImageProps>`
    height: 100%;
    background-color: ${theme.palette.white};
    border-radius: 1.37rem 1.37rem 0 0;
    width: 100%;
    object-fit: cover;
    object-position: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 1.5rem;
    border-bottom: 1px solid ${theme.palette.lightGray};
`;


export const StyledCompletedOverlay = styled.div`
    background-color: ${theme.palette.atosLightBlueRGBA50};
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 1.37rem 1.37rem 0 0;
`;

export const StyledCertificateIcon = styled.div`
    width: 11rem;
    height: 11rem;
    margin-top: 2rem;
`;

export const StyledProgressBarOverlay = styled.div`
    pointer-events: none;
    padding-inline: 2rem;
    position: absolute;
    width: 100%;
    height: 100%;
    background: linear-gradient(0deg, rgba(255, 255, 255, 1) 20%, rgba(160, 160, 189, 0) 53%);
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    border-radius: 0 0 1.37rem 1.37rem;
`;

export const StyledProgressBarContainer = styled.div`
    width: 100%;
    margin-top: auto;
    margin-bottom: 1rem;
`;

export const StyledProgressBarBackground = styled.div`
    width: 100%;
    background-color: #e0e0e0;
    border-radius: 8px;
    overflow: hidden;
    margin-top: 1rem;
    margin-bottom: 0.5rem;
    box-shadow: inset 0px 2px 2px rgba(0, 0, 0, 0.1);
`;

export const StyledProgressBar = styled.div<{ progress: number }>`
    width: ${(props) => props.progress}%;
    background-color: ${theme.palette.atosBlue2};
    height: 0.7rem;
`;

export const StyledProgressBarText = styled.div`
    display: flex;
    justify-content: flex-end;
`;